import React, { useEffect, useMemo, useRef, useState } from "react";
import { ArrowDown2 } from "../../CustomComponents/SwiftIcon/Icons";

function ReportFilterDropdown({
    label,
    options = [],
    value = [],
    onChange,
    placeholder = "All",
    isSearch = true
}) {

    const ref = useRef(null);

    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {

        const close = (e) => {

            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }

        };

        document.addEventListener("mousedown", close);

        return () => document.removeEventListener("mousedown", close);

    }, []);

    const filtered = useMemo(() => {

        return options.filter(option =>
            option.label.toLowerCase().includes(search.toLowerCase())
        );

    }, [options, search]);

    function toggle(item) {

        if (value.includes(item.value)) {

            onChange(
                value.filter(v => v !== item.value)
            );

        } else {

            onChange([
                ...value,
                item.value
            ]);

        }

    }

    function selectAll() {

        onChange(
            options.map(o => o.value)
        );

    }

    function clearAll() {

        onChange([]);

    }

    const selectedOptions = options.filter(o =>
        value.includes(o.value)
    );

    return (

        <div ref={ref} className="report-filter">

            {label &&
                <label className="report-filter-label">
                    {label}
                </label>
            }

            <div
                className="report-filter-control"
                onClick={() => setOpen(!open)}
            >

                <div className="report-filter-values">

                    {selectedOptions.length === 0 && (
                        <span className="report-filter-placeholder">
                            {placeholder}
                        </span>
                    )}

                    {selectedOptions.slice(0, 2).map(option => (
                        <div
                            key={option.value}
                            className="report-filter-tag"
                        >
                            {option.label}
                        </div>
                    ))}

                    {selectedOptions.length > 2 && (
                        <div className="report-filter-tag more">
                            +{selectedOptions.length - 2}
                        </div>
                    )}

                </div>

                <ArrowDown2 size={16} />

            </div>

            {
                open &&
                <div className="report-filter-popup">

                    {
                        isSearch &&
                        <div className="report-filter-search">

                                <input
                                    className="report-filter-search-input"
                                    placeholder="Search..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />

                        </div>
                    }

                    <div className="report-filter-options">

                        {
                            filtered.map(option => (

                                <label
                                    key={option.value}
                                    className="report-filter-option"
                                >

                                    <input
                                        type="checkbox"
                                        className="report-filter-checkbox"
                                        checked={value.includes(option.value)}
                                        onChange={() => toggle(option)}
                                    />

                                    <span className="report-filter-option-text">

                                        {option.label}

                                    </span>

                                </label>

                            ))
                        }

                    </div>

                    <div className="report-filter-footer">

                        <button
                            className="report-designer-chip-btn"
                            onClick={selectAll}
                        >
                            Select All
                        </button>

                        <button
                            className="report-designer-chip-btn"
                            onClick={clearAll}
                        >
                            Clear
                        </button>

                    </div>

                </div>
            }

        </div>

    );

}

export default ReportFilterDropdown;